import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// O empacotador quebra os caminhos das imagens padrão do Leaflet; sem isto o
// pino não aparece.
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow
});

/**
 * Mapa de ajuste do ponto: o lojista arrasta o pino (ou clica no mapa) e o
 * componente devolve a coordenada. Usa OpenStreetMap — não precisa de chave de
 * API, e o link que vai para o site continua sendo do Google Maps (BDM-1140).
 */
export const MapLocationPicker = ({ latitude, longitude, change, zoom = 17, height = 260 }) => {
    const containerRef = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    // Espelho do callback: o mapa é criado uma vez e os handlers não podem
    // ficar presos ao closure do primeiro render.
    const changeRef = useRef(change);

    useEffect(() => {
        changeRef.current = change;
    }, [change]);

    useEffect(() => {
        if (!containerRef.current || mapRef.current) return;

        const map = L.map(containerRef.current).setView([latitude, longitude], zoom);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap',
            maxZoom: 19
        }).addTo(map);

        const marker = L.marker([latitude, longitude], { draggable: true }).addTo(map);

        marker.on('dragend', () => {
            const position = marker.getLatLng();
            changeRef.current?.({ latitude: position.lat, longitude: position.lng });
        });

        map.on('click', event => {
            marker.setLatLng(event.latlng);
            changeRef.current?.({ latitude: event.latlng.lat, longitude: event.latlng.lng });
        });

        mapRef.current = map;
        markerRef.current = marker;

        return () => {
            map.remove();
            mapRef.current = null;
            markerRef.current = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Coordenada trocada por fora (link novo colado): recentraliza o mapa.
    useEffect(() => {
        if (!mapRef.current || !markerRef.current) return;

        const current = markerRef.current.getLatLng();

        if (current.lat === latitude && current.lng === longitude) return;

        markerRef.current.setLatLng([latitude, longitude]);
        mapRef.current.setView([latitude, longitude], mapRef.current.getZoom());
    }, [latitude, longitude]);

    return <div ref={containerRef} style={{ height, width: '100%', borderRadius: 8 }} />;
}

export default MapLocationPicker;
